import React, { useEffect, useState } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import s from './userwriting.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import {GreenButton, BlueButton} from '../components/MyButton';
import {modifiedDate} from '../middleware/dateControl';

export default function Userwriting() {
	const navigate = useNavigate();
	
	const [writings, setWritings] = useState([]);
	const fetchData = () => {		
		getData('userWritingApi/listUserWriting', navigate)
		.then(res => {
				setWritings(res.data);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	
	return (<div>
			<div className={s.procedure}>
				<div>change user writing procedure</div>
				<div>1. change tutor group id in user writing</div>
				<div>2. change json in tutor_group_x_user</div>
			</div>
		
		
			<div className={s.uw_mainRowHolder}>
				<div style={{width:"50px"}}>id</div>
				<div style={{width:"200px"}}>title</div>
				
				<div style={{width:"50px"}}>teacher</div>
				
				<div style={{width:"50px"}}>Stu Id</div>
				<div style={{width:"150px"}}>student</div>
				
				<div style={{width:"50px"}}>TG id</div>
				<div style={{width:"300px"}}>TG Title</div>
				<div style={{width:"30px"}}>Zoom</div>
				<div style={{width:"30px"}}>Day</div>
				<div style={{width:"30px"}}>lesson</div>
				<div style={{width:"200px"}}>zoomStartDate</div>
			</div>
		
			{
				writings.map((w, indexW) => (<div className={s.uw_mainRowHolder} key={indexW}>
					<div style={{width:"50px"}}>{w.id}</div>
					<div style={{width:"200px"}}>{w.title}</div>
					
					<div style={{width:"50px"}}>{w.teacherName}</div>
					
					<div style={{width:"50px"}}>{w.studentId}</div>
					<div style={{width:"150px"}}>{w.studentUsername}</div>
					
					<div style={{width:"50px"}}>{w.tutorGroupId}</div>
					<div style={{width:"300px"}}>{w.tgTitle}</div>
					<div style={{width:"30px"}}>{w.zoomId}</div>
					<div style={{width:"30px"}}>{w.dayId}</div>
					<div style={{width:"30px"}}>{w.lessonId}</div>
					<div style={{width:"200px"}}>{modifiedDate(w.zoomStartDate)}</div>
				</div>))
			}
		</div>
	);
}